import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { FEATURE_MODULES } from '@/constants/feature-modules';
import { useIsFeatureModuleEnable } from '@/utils/useIsFeatureModuleEnable';

type CustomerSatisfactionModuleGateProps = {
  children: ReactNode;
};

/** Prevents direct navigation when Customer Satisfaction is not enabled. */
export function CustomerSatisfactionModuleGate({ children }: CustomerSatisfactionModuleGateProps) {
  const enabled = useIsFeatureModuleEnable(FEATURE_MODULES.CustomerSatisfaction);
  return enabled ? children : <Navigate to="/unauthorized" replace />;
}
